import { ViewController } from 'ionic-angular/navigation/view-controller';
import { BllOrtak } from './../../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import {  NavController, NavParams } from 'ionic-angular';
import { Ortak } from '../../../../providers/ortak';

/**
 * Generated class for the KasaeklePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-kasaekle',
  templateUrl: 'kasaekle.html',
})
export class KasaeklePage {
  kasa:any={ID:-1};
  KasaVw:any={};

  constructor(public navCtrl: NavController,
    public ortak:Ortak,
    public bllOrtak:BllOrtak,
    public viewCtrl:ViewController,
     public navParams: NavParams) {
    if (navParams.get("KasaVw") != null) {
      this.KasaVw = navParams.get("KasaVw");
      var data = new FormData();
      data.append("Kasa_id", this.KasaVw.ID);
      this.bllOrtak.islem(data, "KasaGetirByID", "", false).then(a => {
        var Sonuc = <any>a;
        this.kasa = Sonuc.SonucObject;
    
       
      }
      )
    }
  }

  ionViewDidLoad() {

  }
  boslukKontrol() {
    var mesaj = "";
    
    if (this.kasa.Name == null || this.kasa.Name == "") {
      mesaj = mesaj + "Lütfen Kasa adını giriniz. <br/>";
    }

    if (mesaj == "") {
      return true;
    }
    else {
      this.ortak.showBasicAlert("Uyarı", mesaj);
      return false;
    }
  }
  kaydet() {

    var formData = new FormData();
   
    if (this.boslukKontrol()) {
      formData.append("Kasa_json", JSON.stringify(this.kasa));
     
      this.bllOrtak.islem(formData, "KasaEkleGuncelle", "", false).then(a => {
        var sonuc = <any>a;
        if(sonuc.Sonuc==1) this.ortak.showBasicAlert("Başarılı","İşlem Başarılı");
       

      })
    }
    this.cikis();
    }
    cikis()
    {
      this.viewCtrl.dismiss();
    }

}



// WEBPACK FOOTER //
// ./src/pages/Yonetim/KasaIslemleri/kasaekle/kasaekle.ts